import { Box, LinearProgress, Modal, Typography } from "@mui/material";
import React, { useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Button from "../../../Subcomponents/Button";
import cssClasses from "./uploadNbfcDetailModal.module.css";
import { useEffect } from "react";
import { insertNBFCDetails } from "../../../Services/Bank";
import { errorTost, successTost } from "../../../Services/Toast";
import FailedNbfcRecord from "../FailedNbfcModal/FailedNbfcRecord";

const UploadNbfcDetailModal = ({
  open,
  handleClose,
  selectedData,
  allNbfcData,
}) => {
  const [stepperValue, setStepperValue] = useState(1);
  const [totalEntriesCount, setTotalEntriesCount] = useState(0);
  const [errorEntry, setErrorEntry] = useState([]);
  const [isFieldEntriesModalOpen, setIsFieldEntriesModalOpen] = useState(false);

  useEffect(() => {
    validateNbfcData();
  }, []);

  async function validateNbfcData() {
    setStepperValue(2);
    const errorData = [];
    const payload = [];
    const selectData =
      allNbfcData?.length === 0
        ? selectedData?.forEach((v) => payload.push(v))
        : selectedData?.map((v) => {
            const index = [...allNbfcData, ...payload]?.findIndex(
              (i) => i.nbfcName.toLowerCase() === v?.nbfcName.toLowerCase()
            );
            if (index === -1) {
              if (/\d/.test(v?.nbfcName) === true) {
                errorData.push({
                  ...v,
                  message: "NBFC Can't contain numeric values!",
                });
              } else if (v?.nbfcName?.trim()?.length === 0) {
                errorData.push({
                  ...v,
                  message: "NBFC name can not be empty!",
                });
              }else if (!/^[A-Za-z0-9 ]+$/.test(v?.nbfcName)) {
                errorData.push({
                  ...v,
                  message:"NBFC name can not contain special characters!"
                });
              } else {
                payload.push(v);
              }
            } else {
              errorData.push({
                ...v,
                message: "Duplicate Entry!",
              });
            }
          });

    setErrorEntry(errorData);

    uploadDataToServer(payload);
  }

  async function uploadDataToServer(payload) {
    setStepperValue(3);
    setTotalEntriesCount(payload?.length);
    if (payload.length > 0) {
      await insertNBFCDetails(payload)
        .then((result) => {
          successTost("NBFC details added successfully!");
          setStepperValue(4);
        })
        .catch((err) => {
          errorTost(err.message);
        });
    } else {
      setStepperValue(4);
    }
  }
  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={[
          { ".MuiBackdrop-root": { background: "rgba(193, 201, 210, 0.7)" } },
        ]}
        disableAutoFocus={true}
      >
        <Box className={cssClasses.modalWrapper}>
          <div className={cssClasses.header}>
            <h1>Uploading Data</h1>
          </div>

          <div className={cssClasses.mainContainer}>
            <div className={cssClasses.mainContainerWrapper}>
              {/* Step 1 */}
              <div className={cssClasses.progressCardContainer}>
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"space-between"}
                  mb={"1rem"}
                  p={"1rem 1.5rem"}
                >
                  <Typography
                    color={"#0F0F0F"}
                    fontSize={"2rem"}
                    lineHeight={"3rem"}
                    fontWeight={400}
                  >
                    Reading Excel
                  </Typography>
                  {stepperValue > 1 ? (
                    <CheckCircleIcon
                      color={"primary"}
                      style={{ width: "2rem", height: "2rem" }}
                    />
                  ) : (
                    <CheckCircleIcon
                      color={"primary"}
                      style={{ width: "2rem", height: "2rem", opacity: "0.5" }}
                    />
                  )}
                </Box>
                {stepperValue > 1 ? (
                  <LinearProgress variant="determinate" value={100} />
                ) : (
                  <LinearProgress />
                )}
              </div>

              {/* Step 2 */}
              <div className={cssClasses.progressCardContainer}>
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"space-between"}
                  mb={"1rem"}
                  p={"1rem 1.5rem"}
                >
                  <Typography
                    color={"#0F0F0F"}
                    fontSize={"2rem"}
                    lineHeight={"3rem"}
                    fontWeight={400}
                  >
                    Validating Data in Excel
                  </Typography>
                  {stepperValue > 2 ? (
                    <CheckCircleIcon
                      color={"primary"}
                      style={{ width: "2rem", height: "2rem" }}
                    />
                  ) : (
                    <CheckCircleIcon
                      color={"primary"}
                      style={{ width: "2rem", height: "2rem", opacity: "0.5" }}
                    />
                  )}
                </Box>
                {stepperValue > 2 ? (
                  <LinearProgress variant="determinate" value={100} />
                ) : (
                  <LinearProgress />
                )}
              </div>

              {/* Step 2 */}
              <div className={cssClasses.progressCardContainer}>
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"space-between"}
                  mb={"1rem"}
                  p={"1rem 1.5rem"}
                >
                  <Typography
                    color={"#0F0F0F"}
                    fontSize={"2rem"}
                    lineHeight={"3rem"}
                    fontWeight={400}
                  >
                    Uploading Data to Database
                  </Typography>
                  {stepperValue > 3 ? (
                    <CheckCircleIcon
                      color={"primary"}
                      style={{ width: "2rem", height: "2rem" }}
                    />
                  ) : (
                    <CheckCircleIcon
                      color={"primary"}
                      style={{ width: "2rem", height: "2rem", opacity: "0.5" }}
                    />
                  )}
                </Box>
                {stepperValue > 3 ? (
                  <LinearProgress variant="determinate" value={100} />
                ) : stepperValue === 3 ? (
                  <LinearProgress
                    variant="determinate"
                    value={(errorEntry?.length / totalEntriesCount) * 100}
                  />
                ) : (
                  <LinearProgress />
                )}
              </div>

              <div
                className={cssClasses.progressCardContainer}
                style={{ padding: "1rem 1.5rem" }}
              >
                <Typography
                  color={"#676767"}
                  fontSize={"2rem"}
                  lineHeight={"3rem"}
                  fontWeight={400}
                >
                  Total Entries : {selectedData?.length}
                </Typography>
                <Typography
                  color={"#676767"}
                  fontSize={"2rem"}
                  lineHeight={"3rem"}
                  fontWeight={400}
                >
                  New Entries : {totalEntriesCount}
                </Typography>
                <Typography
                  color={"#676767"}
                  fontSize={"2rem"}
                  lineHeight={"3rem"}
                  fontWeight={400}
                >
                  Failed Entries : {errorEntry?.length}
                </Typography>
              </div>
            </div>
          </div>

          {stepperValue >= 3 && (
            <div className={cssClasses.footer}>
              <Box
                display={"flex"}
                flexDirection={"row"}
                justifyContent={"flex-end"}
              >
                {errorEntry.length > 0 && (
                  <Box marginRight={"2rem"}>
                    <Button
                      style={{
                        color: "#ffffff",
                        backgroundColor: "rgb(21, 94, 239)",
                        width: "auto",
                      }}
                      btnName={"View Failed Entries"}
                      clicked={() => setIsFieldEntriesModalOpen(true)}
                    />
                  </Box>
                )}
                <Button
                  style={{
                    color: "#000",
                    backgroundColor: "#fff",
                    width: "auto",
                  }}
                  btnName={"Close"}
                  clicked={() => handleClose()}
                />
              </Box>
            </div>
          )}
        </Box>
      </Modal>

      {isFieldEntriesModalOpen && (
        <FailedNbfcRecord
          open={isFieldEntriesModalOpen}
          handleClose={() => {
            setIsFieldEntriesModalOpen(false);
          }}
          fieldEntriesArray={errorEntry?.map((m, i) => ({ ...m, id: i }))}
        />
      )}
    </>
  );
};

export default UploadNbfcDetailModal;
